import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Wrapper from './Wrapper';
import WrapperB from './WrapperB';
import DemoScreen from './screens/demoScreen/demoScreen';
import ThankYouScreen from './screens/thankYouScreen/ThankYouScreen';
import PrivacyScreen from './screens/privacyScreen/PrivacyScreen';

function App() {
  useEffect(() => {
    const saved = sessionStorage.getItem('scrollY');
    if (saved) {
      const y = parseInt(saved, 10);
      sessionStorage.removeItem('scrollY');
      const restore = () => {
        window.scrollTo(0, y);
        if (window.scrollY < y - 50) {
          requestAnimationFrame(restore);
        }
      };
      setTimeout(restore, 100);
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<WrapperB />} />
        <Route path="/me" element={<WrapperB />} />
        <Route path="/versiona" element={<Wrapper />} />
        <Route path="/demo" element={<DemoScreen />} />
        <Route path="/תודה" element={<ThankYouScreen />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
      </Routes>
    </div>
  );
}

export default App;
